var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuestionMarkRoundedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 6A5.6 5.6 0 11.4 6a5.6 5.6 0 0111.2 0zM6 3.9a.7.7 0 00-.607.35.7.7 0 11-1.212-.7A2.1 2.1 0 116.7 6.581V6.7a.7.7 0 11-1.4 0V6a.7.7 0 01.7-.7.7.7 0 100-1.4zm0 5.6a.7.7 0 100-1.4.7.7 0 000 1.4z"
  })));
}

export default __webpack_public_path__ + "static/media/questionMarkRoundedFilled.49a2d8c8.svg";
export { SvgQuestionMarkRoundedFilled as ReactComponent };